import { Col, Row } from "react-bootstrap";

interface IItems {
  itemName: string;
  id: number;
}

interface IProps {
  items: IItems[];
  onChange: (item: IItems) => void;
  selectedItemId: number;
}

const SettingItem = (props: IProps) => {
  const { items, onChange, selectedItemId } = props;

  return (
    <>
      {items.map((i, index) => {
        return (
          <Row key={i.id} className={`${index !== 0 && `mt-2`}`}>
            <Col
              className={`font-weight-400 font-size-12 ${
                selectedItemId === i.id
                  ? `text-setting-item-selected bg-background-4`
                  : `modal-title`
              } py-2 px-3 rounded cursor-pointer`}
              onClick={() => {
                onChange(i);
              }}
            >
              {i.itemName}
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default SettingItem;
